import * as React from 'react';

/**
 * Mount Ant Select/DatePicker popups into a fixed sentinel that spans the
 * safe content width. Avoids off-screen / clipped menus when a parent uses
 * `transform` (PWA bottom sheets) or when `popupMatchSelectWidth: false`
 * sizes the list wider than the viewport.
 */
export function usePwaDropdownSentinel(
  enabled: boolean
): (trigger: HTMLElement) => HTMLElement {
  const sentinelRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!enabled) {
      sentinelRef.current?.remove();
      sentinelRef.current = null;
    }
    return () => {
      sentinelRef.current?.remove();
      sentinelRef.current = null;
    };
  }, [enabled]);

  return React.useCallback(
    (_trigger: HTMLElement) => {
      if (!enabled || typeof document === 'undefined') {
        return document.body;
      }
      if (!sentinelRef.current) {
        const el = document.createElement('div');
        el.className = 'scope-pwa-dropdown-sentinel';
        document.body.appendChild(el);
        sentinelRef.current = el;
      }
      return sentinelRef.current;
    },
    [enabled]
  );
}
